import React, { Component } from "react";
import { Button, Upload, message } from "antd";
import { injectIntl } from "react-intl";
import { REQUEST_TYPE } from "../../../../constant";
import { Common } from "../../../../Helper/urls";
import { doRequest } from "../../../../Helper/network";
import messages from "./messages";


const IMAGEFORMATJPEG = "image/jpeg";
const IMAGEFORMATJPG = "image/jpg";
const IMAGEFORMATPNG = "image/png";
const PDFFORMAT = "application/pdf";
const DOCFORMAT = "application/msword";
const DOCXFORMAT = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

class CommonUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileList: [],
      docs: []
    };
    this.error = false;
  }

  formatMessage = data => this.props.intl.formatMessage(data);

  onStart = file => {
    this.setState({ filename: file.name, progress: 0 });
  };

  onSuccess = (ret, file) => {};

  onError = err => {
  };

  onProgress = ({ percent }, file) => {
    this.setState({ progress: parseInt(percent) });
  };
  onAbort = args => {
  };


    onUploadComplete = (response) => {
    const { handleComplete, onUploadStart, type = "" } = this.props;

    if (onUploadStart) {
      onUploadStart();
    }
	const {responseData:{file_path, originalname}={}} = response;

	const { docs } = this.state;
	const docsCopy = [...docs];
	docsCopy.push({file_path, originalname});
	this.setState({ docs: docsCopy }, () => {
	const { docs, fileList } = this.state;
	if (docs.length === fileList.length) {
          handleComplete(docs);
        
        this.setState({
          fileList: [],
          docs: []
        });
      }
    });
  };
    
    
    handleChange = info => {
	const fileList = info.fileList;
	const { error } = this;
	if (error) {
	    this.setState({ fileList: [], docs: [] });
	} else {
	    this.setState({ fileList: fileList });
	}
    };
    
    beforeUpload = file => {
	const {formatMessage} = this;
	const isJPG = file.type === IMAGEFORMATJPEG;
	const isPNG = file.type === IMAGEFORMATPNG;
	const isPdf = file.type === PDFFORMAT;
	const isJPEG = file.type === IMAGEFORMATJPG;
	const isDOC  = file.type === DOCFORMAT;
	const isDOCX = file.type === DOCXFORMAT;

	
	if (!isJPG && !isPdf && !isPNG && !isJPEG && !isDOC && !isDOCX) {
	    message.error(formatMessage(messages.uploadError));
	}
	
	if (isJPG || isPdf || isPNG || isJPEG || isDOC || isDOCX) {
	    return (isJPG || isPdf || isPNG || isDOC || isDOCX);
	}
	return false; 
    };

    customRequest = ({ file, filename, onError, onProgress, onSuccess }) => {
	const {handleComplete, uploadProps:{multiple=false}={}} = this.props;
	const {fileList} = this.state;
	
	const { onUploadComplete } = this;
	// const onUploadProgress = ({ total, loaded }) => {
	//     onProgress(
	// 	{ percent: Math.round((loaded / total) * 100).toFixed(2) },
	// 	file
	//     );
	// };

	let data = new FormData();
	data.append("file", file, file.name);

	doRequest({
	    //onUploadProgress: onUploadProgress,
	    method: REQUEST_TYPE.POST,
	    data: data,
	    url: Common.getUploadURL()
	}).then(response => {
	    onUploadComplete(response.payload.data);
	});

	return {
	    abort() {}
	};
      
  };
    
    render() {
	const {formatMessage} = this;
    const {
      uploadProps,
	label = `${formatMessage(messages.upload)}`,
      component,
      uploading = false,
      disabled = false
    } = this.props;
    const { handleChange, customRequest } = this;
    const { fileList } = this.state;

    return (
      <Upload
        {...uploadProps}
        customRequest={customRequest}
        showUploadList={false}
        fileList={fileList}
        onChange={handleChange}
        beforeUpload={this.beforeUpload}
      >
        {component ? (
          component
        ) : (
          <Button
            type="ant-btn  mr16 ant-btn-primary ant-btn-background-ghost"
            disabled={disabled}
            loading={uploading}
          >
            {label}
          </Button>
        )}
      </Upload>
    );
  }
}

export default injectIntl(CommonUpload);
